import { render, staticRenderFns } from "./ModelsList.vue?vue&type=template&id=41c9faa5&scoped=true&"
import script from "./ModelsList.vue?vue&type=script&lang=js&"
export * from "./ModelsList.vue?vue&type=script&lang=js&"
import style0 from "./ModelsList.vue?vue&type=style&index=0&id=41c9faa5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c9faa5",
  null
  
)

export default component.exports